import { render, staticRenderFns } from "./ProjectActivityLog.vue?vue&type=template&id=28e5131e&scoped=true"
import script from "./ProjectActivityLog.vue?vue&type=script&lang=js"
export * from "./ProjectActivityLog.vue?vue&type=script&lang=js"
import style0 from "./ProjectActivityLog.vue?vue&type=style&index=0&id=28e5131e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e5131e",
  null
  
)

export default component.exports